export const headerConfig = {
  headerTitle: 'CSME Certificates',
  headerDescription: 'List of CSME Certificates',
  refreshButton: {
    id: 'refresh',
    label: 'Refresh',
    icon: 'RefreshIcon',
  },
};
